import { Link } from 'react-router-dom';
import React from 'react';

import { useUser } from '../../hooks/useUser';


export const AccountTabs = ({ active }) => {

  const { user } = useUser();

  const isActive = (active, to) => to === active ? 'active' : '';

  const isSubscriber = () => !user.user.account.anchor;

  const renderTab = (tab) => (
    <li key={tab.to} className={isActive(active, tab.to)}>
      <Link to={tab.to}>{tab.label}</Link>
    </li>
  );

  const tabs = [
    { label: 'Account', to: '/account', isDisplayed: true },
    { label: 'Subscriptions', to: '/account/subscriptions', isDisplayed: isSubscriber() },
    { label: 'E-Mail Preferences', to: '/account/email_preferences', isDisplayed: true },
  ];

  return (
    <ul className="nav nav-tabs" id="account_tabs">
      { tabs.filter((tab) => tab.isDisplayed).map(renderTab) }
    </ul>
  );
};
